
module.exports = {
    myHost: {
    //    'host':'https://api-v2.createquickcv.com'
       'host':'https://api-staging-quickcv.bitflex.xyz'
    }
};
